import { useLocation, useParams } from "react-router-dom";
import styled from "styled-components";
import * as yup from "yup";
import { useFormik } from "formik";
import { useMutation, useQuery } from "@tanstack/react-query";
import { ToastOptions, toast } from "react-toastify";
import { StyledButton } from "../../../../components/Button/button";
import { theme } from "../../../../helpers/theme";
import { Input } from "../../../../components/Input/input";
import { GoBackButton } from "../../../../components/GoBackButton";
import { updateAvailability } from "../../../../services/warehouses/availability-update";
import { Dayjs } from "dayjs";
import { useState, useEffect } from "react";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { OutlinedInputProps } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { pl } from "date-fns/locale";
import { StorageAreaAvailabilityGetById } from "../../../../services/warehouses/storage-area-availability-get-by-id";
import { StorageArea } from "../../../../services/warehouses/storage-area-availability-get-by-id/types";

export const UpdateAvailabilityForm = () => {
  const { id } = useParams();
  const { state } = useLocation();
  const {id_magazyn, id_obszar, status_dostepnosci} = state;

  const [storageArea, setStorageArea] = useState<StorageArea[]>([]);
  const [availableArea , setAvailableArea] = useState<number>(0);
  const [fromDate, setFromDate] = useState<Dayjs | Date | null | undefined>();
  const [toDate, setToDate] = useState<Dayjs | Date | null | undefined>();
  const [dateError, setDateError] = useState<boolean>(false);
  const [dateFromInvalid, setDateFromInvalid] = useState<string | null>(null);
  const [dateToInvalid, setDateToInvalid] = useState<string | null>(null);


  useEffect(() => {
    if (fromDate === null || toDate === null) {
      setDateError(true);
    } else if (fromDate != null && toDate != null && fromDate > toDate) {
      setDateError(true);
    } else {
      setDateError(false);
    }

    console.log("dateFromInvalid", dateFromInvalid);
    console.log("dateToInvalid",dateToInvalid);
    console.log("dateError", dateError);
  }, [fromDate, toDate]);



  const settings: ToastOptions<{}> = {
    position: "top-center",
    autoClose: 3000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: false,
    theme: "light",
  };

  
  const body = {
    id_magazyn: String(id_magazyn),
  };

  const storageAreaAvailabilityGetById = useQuery(["StorageAreaAvailability"], () => StorageAreaAvailabilityGetById(body), {
    refetchOnMount: true,
    refetchOnWindowFocus: false,

    onSuccess(data) {
      setStorageArea(data.data.payload.obszar_skladowania);
    },
  });

  useEffect(() => {
  storageArea.forEach((item) => {
    item.dostepnosc.forEach(element => {
      if (element.id_dostepnosc === id) {
        setFromDate(element.data_od);
        setToDate(element.data_do);
        setAvailableArea(element.powierzchnia_dostepna);
      }
    });
  });
  }, [storageArea, id]);


  const UpdateAvailabilityMutation = useMutation(updateAvailability, {
    onSuccess: (res) => {
      toast.success("Dodano pomyślnie!", { toastId: "AddedSuccessfully", ...settings });
    },
  });

  const validationSchema = yup.object({
    powierzchnia_dostepna: yup
      .number()
      .min(0, "Powierzchnia nie może być mniejsza od 0")
      .typeError("Powierzchnia musi być liczbą")
      .required("Powierzchnia jest wymagana"),
  });


  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      id_obszar_skladowania: id,
      powierzchnia_dostepna: availableArea,
      data_od: fromDate,
      data_do: toDate,
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      const body = {
        id_dostepnosc: values.id_obszar_skladowania,
        powierzchnia_dostepna: values.powierzchnia_dostepna,
        data_od: values.data_od === undefined ? (status_dostepnosci === 1 || status_dostepnosci === 3 ? fromDate : null) : (status_dostepnosci === 1 || status_dostepnosci === 3 ? values.data_od : null),
        data_do: values.data_do === undefined ? (status_dostepnosci === 2 || status_dostepnosci === 3 ? toDate : null) : (status_dostepnosci === 2 || status_dostepnosci === 3 ? values.data_do : null),
      };
      UpdateAvailabilityMutation.mutate(body);
    },
  });

  
  return (
    <>
    <ButtonWrapper>
    <GoBackButton description={"Powrót"} goToUrl={-1} />
    </ButtonWrapper>
    <BasicFormWrapper onSubmit={formik.handleSubmit}>
      <FormWrapper>
      
        <Input
          label="Powierzchnia Dostepna"
          id="powierzchnia_dostepna"
          name="powierzchnia_dostepna"
          value={formik.values.powierzchnia_dostepna}
          onChange={formik.handleChange}
          error={formik.touched.powierzchnia_dostepna && Boolean(formik.errors.powierzchnia_dostepna)}
          helperText={formik.touched.powierzchnia_dostepna && formik.errors.powierzchnia_dostepna}
          onBlur={formik.handleBlur}
          variant="filled"
          style={{ marginTop: 11 }}
        />
        
        <LocalizationProvider adapterLocale={pl} dateAdapter={AdapterDateFns}>
          <DatePickersWrapper>
            <DesktopDatePicker
              views={["day"]}
              label="Ważny od"
              disabled={status_dostepnosci === 1 || status_dostepnosci === 3 ? false : true}
              maxDate={toDate}
              value={fromDate}
              InputProps={{ disableUnderline: true } as Partial<OutlinedInputProps>}
              onError={(error)=>setDateFromInvalid(error)}
              onChange={(newValue) => {
                setFromDate(newValue);
              }}
              renderInput={(params) => (
                <InputWrapper style={{ justifyContent: "flex-start" }}>
                  <Input
                    {...params}
                    helperText={null}
                    variant="filled"
                    sx={{
                      width: "100%",
                      // minWidth: "300px",
                    }}
                  />
                </InputWrapper>
              )}
            />

              <DesktopDatePicker
                views={["day"]}
                label="Ważny do"
                // disablePast
                disabled={status_dostepnosci === 2 || status_dostepnosci === 3 ? false : true}
                minDate={fromDate}
                value={toDate}
                InputProps={{ disableUnderline: true } as Partial<OutlinedInputProps>}
                onError={(error)=>setDateToInvalid(error)}
                onChange={(newValue) => {
                  setToDate(newValue);
                }}
                renderInput={(params) => (
                  <InputWrapper style={{justifyContent: "flex-end"}}>
                    <Input
                      {...params}
                      helperText={null}
                      variant="filled"
                      sx={{
                        //  marginRight: "13px",
                        width: "100%",
                        // minWidth: "300px",
                      }}
                    />
                  </InputWrapper>
                )}
              />
            </DatePickersWrapper>
          </LocalizationProvider>

        <StyledButton 
          disabled={
          !formik.isValid 
          || UpdateAvailabilityMutation.isLoading 
          || ((status_dostepnosci === 3 ? (dateFromInvalid === null || dateFromInvalid === "minDate" ? false : true) : (dateToInvalid === null ? false : true)) 
          || status_dostepnosci === 2 || status_dostepnosci === 1 ? dateError : (dateError || (dateFromInvalid === "minDate" || dateFromInvalid === null ? false : true) || (dateToInvalid === "maxDate" || dateToInvalid === null ? false : true)))} 
          type="submit" 
          variant="contained"
        >
          Zapisz
        </StyledButton>
      </FormWrapper>
    </BasicFormWrapper>
    </>
  );
};

export default UpdateAvailabilityForm;

const BasicFormWrapper = styled.form`
  width: 100%;
  margin-bottom: 40px;
  display: flex;
  justify-content: center;
  // padding: 0 40px;

  @media (${theme.device.laptop}){
    width: 100%;
    // padding: 0 10px;
  }
`;

const FormWrapper = styled.div`
  width: 90%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width:260px;
  max-width:420px;
  gap: 25px;

  @media (${theme.device.laptop}){
    width: 100%;
  }
`;

const ButtonWrapper = styled.div`
  margin-left: 320px;
`;

const DatePickersWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media ${theme.device.Mlaptop} {
    flex-direction: column;
    gap: 10px;
  }
  width: 100%;
`;

const InputWrapper = styled.div`
  width: 49%;
  display: flex;

  @media ${theme.device.Mlaptop} {
    width: 100%;
  }
`;

